import { AutogenLayoutManualSettlementList } from "./autogen/AutogenLayoutManualSettlementList";
import { Navigation } from "@mcleod/core";

export class ManualSettlementList extends AutogenLayoutManualSettlementList {
    override onLoad(): void {
        this.mainDataSource.orderBy = [{ field: "payee_id", sort: "asc" }, { field: "check_date", sort: "desc" }];
        this.buttonPrintPost.addClickListener(() => {
            Navigation.navigateTo("lme/settlement/reports/ManualSettlementPostingReport", { newTab: true });
        });
    }
}
